import React from 'react';
import styles from './index.module.scss';

type Props = {
  title?: string;
  children: any;
  onClose: () => void
};

const Modal = (props: Props) => {
  return (
    <>
      <div className={styles.overlay} />
      <div className={styles.wrapper}>
        <div className={styles.close} onClick={props.onClose}>
          <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1.53033 0.469669C1.23744 0.176777 0.762562 0.176777 0.469669 0.469669C0.176776 0.762564 0.176776 1.23744 0.469669 1.53033L7.93934 9L0.46967 16.4697C0.176777 16.7626 0.176777 17.2374 0.46967 17.5303C0.762563 17.8232 1.23744 17.8232 1.53033 17.5303L9 10.0607L16.4697 17.5303C16.7626 17.8232 17.2374 17.8232 17.5303 17.5303C17.8232 17.2374 17.8232 16.7626 17.5303 16.4697L10.0607 9L17.5303 1.53033C17.8232 1.23744 17.8232 0.762563 17.5303 0.469669C17.2374 0.176776 16.7626 0.176776 16.4697 0.469669L9 7.93934L1.53033 0.469669Z" fill="#111520"/>
          </svg>
        </div>
        {props.title && <div className={styles.header}>{props.title}</div>}
        <div className={styles.body}>
          {props.children}
        </div>
      </div>
    </>
  );
};

export default Modal;
